module.exports = __webpack_public_path__ + "static/media/insane-icon.b6086867.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/insane-icon.svg
// module id = 1065
// module chunks = 0